import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $tone?: 'main' | 'alt';
  $fullWidth?: boolean;
  $fontSize?: 'current' | 'small';
  $article?: boolean;
  $center?: boolean;
}

export const Wrapper = styled.div.withConfig({ componentId: 'sc-13ceeau-0' })<WrapperProps>`
    max-width: ${(props) => props.theme.size.contentMaxWidth};
    font-size: var(--font-size-regular);
    text-wrap: pretty;

    h1 {
        font-size: var(--font-size-h1);
        line-height: var(--line-height-h1);
        letter-spacing: -0.02em;
    }

    h2 {
        font-size: var(--font-size-h2);
        line-height: var(--line-height-h2);
    }

    h3 {
        font-size: var(--font-size-h3);
        line-height: var(--line-height-h3);
    }

    h4 {
        font-size: var(--font-size-h4);
        line-height: var(--line-height-h4);
    }

    h5 {
        font-size: var(--font-size-h5);
        line-height: var(--line-height-h5);
    }

    h6 {
        font-size: var(--font-size-h6);
        line-height: var(--line-height-h6);
        letter-spacing: 0.15em;
        text-transform: uppercase;
        opacity: 0.8;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-top: ${size(4)};
        margin-bottom: ${size(3)};
        font-weight: var(--font-weight-bold);

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    p {
        margin: 1em 0;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }

        img {
            margin: 0;
        }
    }

    a {
        text-decoration: underline;
        font-weight: inherit;

        &:not(:hover) {
            color: var(--c-link);
        }
    }

    img {
        display: block;
        width: 100%;
        margin: 1em 0;
    }

    li + li {
        margin-top: 0.25em;
    }

    ${({ $fullWidth }) =>
      $fullWidth &&
      css`
            max-width: 100%;
        `}

    ${({ $center }) =>
      $center &&
      css`
            margin: 0 auto;
        `}

    ${({ $tone }) =>
      $tone === 'main'
        ? css`
                  color: var(--c-text-main);
              `
        : $tone === 'alt'
          ? css`
                  color: var(--c-text-muted);
              `
          : css`
                  color: currentColor;
              `}

              ${({ $fontSize }) =>
                $fontSize === 'current'
                  ? css`
                  font-size: 1em;
              `
                  : $fontSize === 'small'
                    ? css`
                  font-size: var(--font-size-small);
              `
                    : undefined}

    ${({ $article }) =>
      $article &&
      css`
            margin: 0 auto;

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                margin-top: ${size(4)};
                margin-bottom: ${size(1)};
            }

            p {
                margin: ${size(1)} 0 ${size(4)};

                img {
                    margin-left: ${size(-2)};
                    width: calc(100% + ${size(4)});

                    ${({ theme }) => theme.breakpoint.Md} {
                        max-width: ${size(133)};
                        width: calc(100vw - ${size(8)});
                        margin-left: 50%;
                        transform: translateX(-50%);
                    }
                }
            }
        `}
`;
